module.exports = __webpack_public_path__ + "static/media/tm.d55963e2.svg";